import { useState } from 'react'
import { useAdminRoles } from '../../../features/admin/use-admin-roles'
import { useAdminUsers, useAssignUserRole } from '../../../features/admin/use-admin-users'
import { AdminPage, adminError } from './admin-bits'
import { EmptyRow, Inline, inputCls, td, th } from './controls'
import { Card } from './ui'

export function PorcelainAdminUsers() {
  const users = useAdminUsers()
  const roles = useAdminRoles()
  const assign = useAssignUserRole()
  const [target, setTarget] = useState<string | null>(null)
  const list = users.data ?? []
  const roleOpts = roles.data ?? []
  return (
    <AdminPage
      title="Users"
      subtitle="Organization members and their roles."
      loading={users.isLoading}
      error={!!users.error}
    >
      <Card title={`${list.length} user${list.length === 1 ? '' : 's'}`}>
        {assign.error ? (
          <div className="px-5 pt-3">
            <Inline tone="bad">{adminError(assign.error)}</Inline>
          </div>
        ) : null}
        {list.length === 0 ? (
          <EmptyRow>No users in this organization.</EmptyRow>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-[14px]">
              <thead>
                <tr>
                  <th className={th}>Name</th>
                  <th className={th}>Email</th>
                  <th className={th}>Role</th>
                </tr>
              </thead>
              <tbody>
                {list.map((u) => (
                  <tr key={u.id} className="transition-colors hover:bg-[var(--v1-accent-soft)]">
                    <td className={`${td} font-medium`}>{u.name}</td>
                    <td className={`${td} text-[var(--color-muted)]`}>{u.email}</td>
                    <td className={td}>
                      <select
                        aria-label={`Role for ${u.name}`}
                        className={`${inputCls} max-w-[220px]`}
                        value={u.role}
                        disabled={assign.isPending && target === u.id}
                        onChange={(e) => {
                          setTarget(u.id)
                          assign.mutate({ userId: u.id, role: e.target.value })
                        }}
                      >
                        {roleOpts.some((r) => r.id === u.role) ? null : <option value={u.role}>{u.role}</option>}
                        {roleOpts.map((r) => (
                          <option key={r.id} value={r.id}>
                            {r.name}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </AdminPage>
  )
}
